import { Injectable, inject } from '@angular/core';
import { Observable, firstValueFrom, of } from 'rxjs';
import { DatabaseService } from './base/database.service';
import { SupabaseService } from './base/supabase.service';
import { Contract, SignedContract } from '../models/contract';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class SignedContractService extends DatabaseService<SignedContract> {
  private lambdaClient = inject(SupabaseService);

  constructor() {
    super('cp_signed_contract');
  }

  async doDownload(sc_id: string) {
    return this.supabase.storage
      .from('doc_signed')
      .createSignedUrl(sc_id + '.pdf', 3600, { download: true });
  }

  async doDownloadToSignedContract(bucket: string, sc_id: string) {
    return this.supabase.storage.from(bucket).createSignedUrl(sc_id, 3600, {});
  }

  async getByIdWithRelations(id: string): Promise<SignedContract> {
    const { data, error } = await this.supabase
      .from(this.table)
      .select()
      .eq('id', id)
      .select(
        '*, cp_contract(*), cp_claim(*, cp_case(*)), cp_user(*, cp_pii(*))'
      );

    if (error) throw error;
    console.log('GET', data);

    return data[0] ?? null;
  }

  async getContractSignedByUser(
    userId: string,
    addCpWithdrawRequest: boolean = false
  ): Promise<any> {
    const { data, error } = await this.supabase
      .from('cp_signed_contract')
      .select(
        `*
        ${
          addCpWithdrawRequest
            ? ',cp_claim:claim_id(id,cp_withdrawal_requests(*))'
            : ''
        }`
      )
      .eq('signer_id', userId);

    if (error) {
      throw new Error(`Erro ao buscar contrato assinado: ${error.message}`);
    }

    return data ?? [];
  }

  async getContractsByClaim(
    claimId: string,
    addCpWithdrawRequest: boolean = false
  ): Promise<any> {
    const { data, error } = await this.supabase
      .from('cp_signed_contract')
      .select(
        `*
        ${
          addCpWithdrawRequest
            ? ',cp_claim:claim_id(id,cp_withdrawal_requests(*))'
            : ''
        }`
      )
      .eq('claim_id', claimId);

    if (error) {
      throw new Error(`Erro ao buscar contratos do claim: ${error.message}`);
    }

    return data ?? [];
  }

  async doSign(
    contract_id: string,
    claim_id: string,
    signature_bytes: string,
    user_agent: string,
    ip: string
  ) {
    const body = {
      contract_id,
      claim_id,
      signature_bytes,
      user_agent,
      ip,
    };
    // CPK-5212: assinar cria uma linha em cp_signed_contract, então o POST não pode ser reenviado
    // em silêncio. Pelo HttpClient, o NetworkInterceptor corta aos 20 s, mostra o modal de rede e
    // reenvia a mesma requisição quando o usuário clica em tentar de novo — antes de o prazo
    // interno do servidor (~23 s) responder. callLambda é um fetch sem timeout nem retry, e o erro
    // carrega status e corpo, de onde o modal lê o details.code.
    return this.lambdaClient.callLambda('sign-contract-v2', 'POST', body);
  }
}
